import React from "react";
import { adds } from "../../../assets";
import Button from "../../../components/Button";
import Node from "../../../components/threejs";
import "./index.css";
import { motion } from "framer-motion";

const Hero = ({ variants }) => {
  return (
    <div className="hero flex alignCenter relative">
      <img className="blur blur1" src={adds.blur1} alt="Blur" />
      <div className="container-lg flex flexCol">
        <div className="textContainer flex flexCol">
          <motion.h5
            variants={variants}
            initial={"initial"}
            animate={"ani"}
            custom={0.3}
          >
            Boost your business
          </motion.h5>
          <motion.h1
            variants={variants}
            initial={"initial"}
            animate={"ani"}
            custom={0.6}
          >
            Algorithms to impact your business
          </motion.h1>
          <motion.p
            variants={variants}
            initial={"initial"}
            animate={"ani"}
            custom={0.9}
          >
            Experts in Artificial Intelligence, Machine Learning and Data Science since 2018
          </motion.p>
          <Button
            text="Contact"
            color="white"
            href="mailto:contacto@replaceit.ai"
            type={"a"}
            variants={variants}
            delay={1.2}
          />
        </div>
        <Node />
      </div>
    </div>
  );
};

export default Hero;
